import { Chip as MuiChip } from "@mui/material";
import { IChipProps } from "./types";

function Chip({ label, ...props }: IChipProps) {
  return <MuiChip label={label} {...props} />;
}

export default Chip;
